import { User } from '../types/api/UsersTypes';
import { CollectionResponse } from '../types/api/CollectionsIndexTypes';
import { CollectionsShowResponse } from '../types/api/CollectionsShowTypes';
import { ProductResponse } from '../types/api/ProductsIndexTypes';
import { AxiosError } from 'axios';
import { CollectionOwnershipResponse, ProductOwnershipResponse } from '../types/api/OwnershipTypes';

import axios from 'axios';
import { ENV } from '../constants/environments';

const apiUrl: string = `${ENV.api.baseURL}`;

const getOwnershipFor = async (
  user: User,
  product: CollectionResponse | CollectionsShowResponse | ProductResponse,
  collectionId?: number,
): Promise<AxiosError  | CollectionOwnershipResponse> => {
  const id = collectionId || product.id;
  const downloadsUrl: string = `${apiUrl}/products/${id}/ownership`;
  const requestParameters = {
    headers: {
      authorization: user.token
    },
  };
  const result = await axios.get(downloadsUrl, requestParameters);
  return result.data;
};

const findOwnershipOf = (product: ProductResponse, ownership: CollectionOwnershipResponse): ProductOwnershipResponse => {
  return ownership.data[product.id];
}

const ownershipHelpers = {
  getOwnershipFor,
  findOwnershipOf,
};

export default ownershipHelpers;
